import { HttpService } from '@/api/shared/http.service'
import { migrateFromV1ToV2 } from '@/api/shared/utils'

import { Story, StoryStep } from './stories.types'

class StoriesService extends HttpService {
  async getStories(projectId: string, module: string) {
    const { data } = await this.axios.get<{ data: Story[] }>(
      migrateFromV1ToV2(this.getPath('/')),
      {
        params: { projectId, module }
      }
    )

    return data
  }

  async getStoriesSteps(id: string) {
    const { data } = await this.axios.get<{ data: StoryStep[] }>(
      this.getPath(`/${id}`)
    )

    return data
  }

  async viewStory(id: string) {
    await this.axios.post<StoryStep[]>(this.getPath(`/steps/${id}/views`), {
      params: { id }
    })
  }
}

const StoriesServiceSingleton = new StoriesService('/api/v1/stories')
export { StoriesServiceSingleton as StoriesService }
